import { styled } from '@mui/material/styles';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  ListItemButton as MuiListItemButton,
  Typography as MuiTypography,
  ListItemIcon as MuiListItemIcon,
  ListItemText,
  Collapse,
  List,
  Stack,
} from '@mui/material';
import { WorkspaceSubMenuItem } from './WorkspaceSubMenuItem';
import { Scrollbar } from 'components/Scrollbar';

const ListItemIcon = styled(MuiListItemIcon, {
  shouldForwardProp: (prop) => prop !== 'wide' && prop !== 'selected',
})(({ wide, selected }) => ({
  color: selected ? '#2b63a4' : '#2e323a',
  '& svg': {
    width: '0.835em',
    height: '0.835em',
  },
  ...(wide && {
    paddingLeft: '4px',
  }),
}));

const ListItemButton = styled(MuiListItemButton, {
  shouldForwardProp: (prop) => prop !== 'wide',
})(({ wide }) => ({
  borderRadius: '6px',
  '&.Mui-selected': {
    backgroundColor: '#a7c4e5',
    fontSize: '18px',
    borderRadius: '6px',
    '&:hover': {
      backgroundColor: '#a7c4e5',
    },
    '.MuiTypography-root': {
      color: '#2b63a4',
    },
  },
  '&:hover': {
    backgroundColor: '#a7c4e5',
    fontSize: '18px',
    borderRadius: '6px',
    '.MuiTypography-root': {
      color: '#2b63a4',
    },
    '.MuiSvgIcon-root': {
      color: '#2b63a4',
    },
  },
  padding: '8px 10px',
  ...(wide && {
    padding: '8px 6px',
    width: '100%',
  }),
}));

const Typography = styled(MuiTypography, {
  shouldForwardProp: (prop) => prop !== 'wide' && prop !== 'selected',
})(({ wide, selected }) => ({
  fontSize: '14px',
  fontWeight: '400',
  ...(!wide && {
    paddingLeft: '9px',
    display: 'none',
  }),
  ...(selected && {
    color: '#2b63a4',
  }),
}));

export const WorkspaceSubMenu = ({ item, wide, selected, sx, toggleWide }) => {
  const tree = useSelector((state) => state.files.tree);
  const addPadding = (array, depth = 1.5) => {
    return array.map((item) => {
      const children = addPadding(item.children, depth + 2.5);
      return { ...item, children, padding: depth };
    });
  };
  const treeWithPadding = addPadding(tree);
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    if (!wide) {
      toggleWide;
      setOpen(true);
      return;
    }
    setOpen(!open);
  };

  return (
    <Stack sx={{ width: '100%' }}>
      <ListItemButton
        component={Link}
        to={item.path}
        sx={{ sx }}
        wide={wide}
        selected={selected}
        onClick={handleClick}
      >
        <ListItemIcon
          wide={wide}
          sx={{ color: '#2e323a' }}
        >
          {item.icon}
        </ListItemIcon>
        <ListItemText
          primary={
            <Typography
              variant="subtitle2"
              wide={wide}
              selected={selected}
            >
              {item.title}
            </Typography>
          }
        />
      </ListItemButton>
      {treeWithPadding.length > 0 && (
        <Collapse
          in={wide ? open : false}
          timeout="auto"
          unmountOnExit
          sx={{ overflowX: 'hidden' }}
        >
          <Scrollbar
            sx={{
              height: '100%',
              width: '210px',
              '& .simplebar-content': {
                height: '100%',
              },
              '& .simplebar-scrollbar:before': {
                background: '#ebebeb',
              },
            }}
            autoHide={false}
          >
            <List
              component="div"
              disablePadding
              sx={{ paddingBottom: '14px' }}
            >
              {treeWithPadding.map((item) => (
                <WorkspaceSubMenuItem
                  item={item}
                  key={item.id}
                  wide={wide}
                  sx={{ pl: item.padding, py: 0, minHeight: 32 }}
                />
              ))}
            </List>
          </Scrollbar>
        </Collapse>
      )}
    </Stack>
  );
};
